export default __webpack_public_path__ + "static/media/logo.aadefa45.svg";